"use client"

import { useSyncExternalStore } from "react"

interface Snowflake {
  id: number
  left: number
  size: number
  duration: number
  delay: number
}

const EMPTY: Snowflake[] = []
let cachedFlakes: Snowflake[] | null = null

function subscribe(callback: () => void) {
  return () => {}
}

function getSnapshot(): Snowflake[] {
  if (typeof window === "undefined") return EMPTY
  if (cachedFlakes) return cachedFlakes
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
  if (prefersReducedMotion) {
    cachedFlakes = EMPTY
    return EMPTY
  }
  const isMobile = window.innerWidth < 768
  const flakeCount = isMobile ? 10 : 30
  cachedFlakes = Array.from({ length: flakeCount }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    size: Math.random() * 6 + 4,
    duration: Math.random() * 4 + 8,
    delay: Math.random() * 10,
  }))
  return cachedFlakes
}

function getServerSnapshot(): Snowflake[] {
  return EMPTY
}

export default function Snowfall() {
  const snowflakes = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)

  return (
    <div className="pointer-events-none fixed inset-0 z-50 overflow-hidden">
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="snowflake absolute text-white opacity-80"
          style={{
            left: `${flake.left}%`,
            fontSize: `${flake.size}px`,
            animationDuration: `${flake.duration}s`,
            animationDelay: `${flake.delay}s`,
            willChange: 'transform',
            transform: 'translateZ(0)',
          }}
        >
          ❄
        </div>
      ))}
    </div>
  )
}
